import { KanbanSquare, LayoutDashboard, Tag } from 'lucide-react';

export enum AgentTab {
  Analytics = 'analytics',
  Catalog = 'catalog',
  Deals = 'deals',
}

export const AGENT_TAB_KEYS = [
  AgentTab.Analytics,
  AgentTab.Catalog,
  AgentTab.Deals,
] as const;

export const isAgentTab = (value: string): value is AgentTab =>
  (AGENT_TAB_KEYS as readonly string[]).includes(value);

export const AGENT_TABS = [
  {
    icon: LayoutDashboard,
    key: AgentTab.Analytics,
    labelKey: 'pages.agent.tabs.analytics' as const,
  },
  {
    icon: Tag,
    key: AgentTab.Catalog,
    labelKey: 'pages.agent.tabs.catalog' as const,
  },
  {
    icon: KanbanSquare,
    key: AgentTab.Deals,
    labelKey: 'pages.agent.tabs.deals' as const,
  },
] as const;
